import React from "react";
import { usePortalContext } from "./portal-context";
export const PortalOutlet = _ref => {
  let {
    as: portalComponent,
    ...props
  } = _ref;
  const portalContext = usePortalContext();
  if (!portalContext) {
    return null;
  }
  const children = Array.from(portalContext.children.values());
  return /*#__PURE__*/React.cloneElement(portalComponent, props, children);
};